import { UploadCommissionSheet } from '../../pages';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import * as yup from 'yup';
import { useFileUpload } from 'use-file-upload';
import { observer } from 'mobx-react';
import { EmployeeController } from '../../controllers';

const UploadCommissionSheetContainer = ({ closeModal, printUpdateEmployeeSalaryData }) => {
	const [loading, setLoading] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [file, selectFile] = useFileUpload();
	const selectClick = () => {
		selectFile({ accept: '.xlsx' });
	};

	const validationSchema = () => {
		return yup.object({
			tag: yup.string().required('Tag is required'),
			narration: yup.string().required('Narration is required'),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);
		const formData = new FormData();
		let fileToSend;
		if (typeof file.source === 'string') {
			fileToSend = await fetch(file.source)
				.then(response => response.blob())
				.then(
					blob =>
						new File([blob], 'name', {
							type: blob.type,
							lastModified: new Date(),
						})
				);
			 formData.append('sheet', fileToSend);
		}
		formData.append('tag', payload.tag);
		formData.append('narration', payload.narration);
		const { status, errorMessage } = await EmployeeController.createCommissionBulkPayment(
			formData
		);
		if (status === constant.Success) {
			setLoading(false);
			setUploaded(true);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};


	return (
		<UploadCommissionSheet
			closeModal={closeModal}
			printUpdateEmployeeSalaryData={printUpdateEmployeeSalaryData}
			uploaded={uploaded}
			onSubmit={onSubmit}
			file={file}
			validationSchema={validationSchema}
			selectClick={selectClick}
			loading={loading}
		/>
	);
};

export default observer(UploadCommissionSheetContainer);
